import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, "_blank", "noopener");
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
              Browse By Category
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 italic">
              Find Your Winning Products
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md lg:text-right leading-relaxed">
            Explore curated product intelligence categories designed to help you identify high-performing items across diverse markets.
          </p>
        </div>

        {/* Dropdown */}
        <div className="mb-8 max-w-md">
          <select
            value={selectedCategory}
            onChange={handleDropdownChange}
            className="w-full px-4 py-3 rounded-lg border border-background-300 bg-white text-sm text-foreground-800 outline-none focus:border-accent-400 transition-colors cursor-pointer appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%3Cpath%20d%3D%22M6%208L1%203h10z%22%20fill%3D%22%23666%22%2F%3E%3C%2Fsvg%3E')] bg-[length:12px] bg-[right_16px_center] bg-no-repeat"
          >
            <option value="">Quick Category Select</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        {/* Category Grid with Images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-white border border-background-200/80 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer hover:-translate-y-0.5"
            >
              {/* Category Thumbnail Image */}
              <div className="w-full h-[120px] md:h-[140px] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} product category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <div className="flex items-center gap-3 p-3 md:p-4">
                <div className="w-7 h-7 rounded-md bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-accent-600 text-xs`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}